/** Physical production line confirmed by the user, independent of the VR shift. */
const documentLines: Readonly<Record<string, string>> = {
  "DIKEY 1": "Elle paketleme 1",
  "DIKEY 2": "Elle paketleme 2",
  "DIKEY 3": "Elle paketleme 3",
  "DIKEY 4": "Elle paketleme 4",
  "PVC": "Elle paketleme 4",
  "TAMTAS 1": "Tam taş poşet",
  "TAMTAS 2": "Çin poşet Lexus",
  "TAMTAS SILINDIR": "Tamtaş silindir",
  "ED1": "Ambalaj folyo yumurta",
  // Same ED1 label with a space, observed on 003421 015 / 19025830, 27 October 2026.
  "ED 1": "Ambalaj folyo yumurta",
  "ED1 - ED2": "Ambalaj folyo yumurta",
  "AMBALAJ 4": "Ambalaj 4 büyük figür",
  // Exact Mikro spelling observed on 26 October 2026; do not infer other Flowpack lines.
  "FLOWOPACK 1 TABLET": "Flowpack 1 Tablet",
  "AMBALAJ 6": "6 hat 38 gram figür",
  "OZDEPAK": "Özdepak",
};

export function productionLineFromDocument(documentNo: string | null): string | null {
  if (!documentNo?.trim()) return null;
  const name = documentNo.trim().normalize("NFD").replace(/[\u0300-\u036f]/gu, "")
    .toUpperCase().replace(/İ/gu, "I").replace(/^VR\s*\d+\s+/u, "")
    .replace(/\s*-\s*/gu, " - ").replace(/\s+/gu, " ").trim();
  return documentLines[name] ?? null;
}

/**
 * The manual-packaging report only settles targets with a confirmed manual line.
 * Flowpack is a production-department document even when it has the same work
 * order and product as a manual-packaging Excel row. Unknown documents remain
 * outside the manual total until their physical line is reviewed.
 */
export function isManualPackagingProductionDocument(documentNo: string | null): boolean {
  const line = productionLineFromDocument(documentNo);
  return line !== null && line !== "Flowpack 1 Tablet";
}
